module.exports = __webpack_public_path__ + "3f97b40b06276391a66d29b76bc34368.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-14.png
// module id = 2186
// module chunks = 0